import { render } from "./AddPaymentMethodDialog.vue?vue&type=template&id=5c5d09b4&scoped=true"
import script from "./AddPaymentMethodDialog.vue?vue&type=script&lang=ts"
export * from "./AddPaymentMethodDialog.vue?vue&type=script&lang=ts"

import "./AddPaymentMethodDialog.vue?vue&type=style&index=0&id=5c5d09b4&lang=scss&scoped=true"
import "./AddPaymentMethodDialog.vue?vue&type=style&index=1&id=5c5d09b4&lang=scss"
script.render = render
script.__scopeId = "data-v-5c5d09b4"

export default script